import FormItem from 'antd/es/form/FormItem';
import { Alert, Modal, Select } from 'antd';
import InfoRow from '../info-row';
import React, { useState } from 'react';
import { PAYMENT_METHOD } from '../../../utils/const';

const { Option } = Select;

export const QuickPaymentForm = ({ selectedRow, handlePayment, show, onCancel, warningMsg, filterStatus = 1 }) => {

	const [paymentMethod, setPaymentMethod] = useState('CASH');

	const renderOptions = () => {
		return Object.keys(PAYMENT_METHOD).map(el => <Option value={el}>{PAYMENT_METHOD[el]}</Option>);
	};

	return <Modal
		title="Thanh toán nhanh đơn nhập hàng"
		visible={show}
		onOk={() => handlePayment(paymentMethod)}
		onCancel={onCancel}>
		<FormItem label={'Chọn phương thức thanh toán'}>
			<Select placeholder="Chọn phương thức thanh toán" value={paymentMethod}
							disabled
							onChange={e => setPaymentMethod(e)}
							style={{ width: '100%' }}>
				{renderOptions()}
			</Select>
		</FormItem>
		<InfoRow label={'Số lượng đơn nhập đủ điều kiện'} labelSpan={14} valueSpan={10}
						 value={selectedRow.filter(el => el.status === filterStatus).length} />
		<InfoRow label={'Số lượng đơn nhập không đủ điều kiện'} labelSpan={14} valueSpan={10}
						 value={<span style={{color: 'red'}}>{selectedRow.filter(el => el.status !== filterStatus).length}</span>} />
		{/*<InfoRow label={'Tổng tiền có thể thanh toán'} labelSpan={14} valueSpan={10}*/}
		{/*				 value={currencyVND(selectedRow.filter(el => el.status === 1).reduce((sum, item) => sum + item.price, 0))} />*/}
		<Alert
			message={warningMsg || '...'}
			type="warning"
			showIcon
		/>
	</Modal>;
};
